export interface IDiscount {
    DiscountedMonths: number;
    Price: number;
    Percentage: number;
    DiscountedDays: number;
}

export interface IChargeTier {
    TotalFreeDays?: number;
    Price: number;
    Currency: string;
    Discount: null | IDiscount;
}

export interface IOffer {
    ProductItems: any;
    ProductBundle:  null | {
        ProductItems: any
    };
    Id: string;
    SkuId: null | string;
    BillingPeriod: string;
    FreeTrialDays?: number;
    BillingDate: string;
    RenewalDate: string;
    ChargeTiers: IChargeTier[];
    RatePlanId: string;
    PaymentMethodIds: string[];
    AllowsNoPaymentMethod: boolean;
    FreeTrialMonths: number;
    TotalFreeDays: number;
    TotalFreeMonths: number;
    Instalment: null | {
        TermInMonths: number;
        NextPaymentCaptureDate: string;
    };
    Conditions: any[];
    EntitlementSetId: string;
    TierRank: number;
    NextBillingDate: string;
    Purchasable: boolean;
    IsAccessCodeApplicable: boolean;
    ProductGroup: string;
    AutoRenew: boolean;
}

export interface IAddon {
    Id: string;
    SkuId: null | string;
    RegularSkuId: null | string;
    BillingType: string;
    BillingPeriod: null | string;
    ProductType: string;
    Entitlements: {
        content: string[];
    };
    Type: string;
    EntitlementSetId: string;
    BillingDate: string;
    ChargeTiers: IChargeTier[];
    PaymentMethodIds: string[];
    AllowsNoPaymentMethod: boolean;
    Purchasable: boolean;
    PurchaseConditions: string[];
    Promotions: Promotion[];
    EventStartDate: string;
    DiscountPercentage: boolean;
    PurchaseDenyReason: null | string;
}

export interface IEntitlement {
    setId: string;
    entitlementIds: string[];
    features: {
        CONCURRENCY: {
            max_devices: number;
            max_ips?: number;
        };
        DEVICE: {
            access_device: string;
            max_registered_devices: number;
        };
    };
    content: string[];
}

export interface IPaymentMethodDetail {
    Id: string;
    BillingCountries: string[];
    SourceSystem: null | string;
    Default: boolean;
    RequireZipCode: boolean;
    GiftCodeDisallowed: boolean;
}

export interface IOffers {
    Offers: IOffer[];
    Addons: IAddon[];
    FreeTrialIneligibilityReason: string;
    DiscountIneligibilityReason: string;
    GiftCode: null | string;
    PaymentMethods: IPaymentMethodDetail[];
    NoOfferFreeTrialMonths: number;
    Entitlements: IEntitlement[];
}

interface Condition {
    AppliesToBillingPeriod: string[];
    RequiresEntitlements: string[];
    DenyReasons: string[] | null;
}

export interface Promotion {
    Id: string;
    DiscountPercentage?: number;
    DiscountAmount?: number;
    Conditions: Condition[];
    IsApplicable?: boolean | null;
}

export enum Periodicity {
    Month = 'Month',
    Annual = 'Annual',
    Instalments = 'Instalments',
    Freetrial = 'Freetrial',
    NonFreeTrial = 'NonFreeTrial',
    Default = 'Default'
}

export type PeriodicityKeys = Exclude<Periodicity, 'Default'>;

export type PaymentMethodKeys =
    | 'ApplePay'
    | 'PayPal'
    | 'CreditCard'
    | 'DirectCarrierBilling'
    | 'KlarnaPayNow';
